export const enum EventType {
	DeviationEnter = 24,
	DeviationLeave = 25,
	DeviationDeactivated = 26,
	DeviationAcknowledged = 27,
}
